import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import InputSelectUI from '../../widgets/form/InputSelectUI'
import './Pricing.css'

const PricingUI = ({context, pricingList, messageList,
  countryList, countryCode, onCountryCodeChange}) =>
  <div className='c_pricing'>
    <div className='country'>
      <InputSelectUI name='countryCode' required={true}
        value={countryCode} optionList={countryList}
        onChange={onCountryCodeChange}
      />
    </div>
    <div className='g_flex_h items'>
      {
        pricingList.map((pricing, i) =>
        <div key={i} className='item-wrap'>
          <div className='item'>
              <div className='row heading'>{pricing.productName}</div>
              <div className='row'>
                <div>{pricing.trialPeriodString}</div>
                <div className='g_small g_muted'>
                  <MessageUI messageList={messageList} messageKey='c_no_cc_cancel_anytime' />
                </div>
              </div>
              <div className='row'>
                <div className='price'>{pricing.pricingString}</div>
                <div className='g_small g_muted'>{pricing.billingIntervalString}</div>
              </div>
              <div className='row'>
                {pricing.resourceString1}
              </div>
            </div>
          </div>
        )
      }
    </div>
  </div>

export default PricingUI
